import { Pagination } from "@mui/material";
import React from "react";

const PaginationControls = ({ page = 1, limit = 100, count = 0, onChange }) => {
  const totalPage = Math.ceil(Number(count) / limit);

  const from = count === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, count);

  return (
    <div class="d-flex align-items-center justify-content-between mt-2">
      <div dataTest="datatable-info" className="">
        <div className="dataTables_info text-nowrap" role="status" ariaLive="polite">
          Showing {from} to {to} of {count} entries
        </div>
      </div>
      <div data-test="datatable-pagination" className="">
        <div className="dataTables_paginate">
          <Pagination
            shape="rounded"
            key={page}
            page={page}
            onChange={(e, value) => onChange(value)}
            count={totalPage || 1}
          />
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;
